/* Author: Vaishnavi
Date: 27/11/2019
Issue NO:-
Description: Spacing issues fixed as per design guidelines
*/
/* Author: Shivakumar
Date: 06/12/2019
Issue NO:- PL-2261
Description: [Misc][Quarters] by default radio button should be on manual.
*/
/* Author: Shivakumar
Date: 10/0/2020
Issue NO:- PL-2640,PL-2547
Description: [QA Instance][24Q Quarters]Not able to create quarters after changing the months to overlapping months and again changing to correct quarters.
*/
<template lang="html">
  <div>
    <div class="permission-alert-msg" v-show="!(ifTeamleaderPermission)">
      You have only view permission.
    </div>
    <div class="udfDetails" :disabled="!(ifTeamleaderPermission)">
      <!-- <div class="margintop-32 udfFields">
        <tl-radio name="uploadType" label="Bulk Upload" id="gender1" value="bulkUpload" v-model="uploadType" />
        <tl-radio name="uploadType" label="Manual" id="gender2" value="manualUpload" v-model="uploadType" />
      </div> -->
      <div>
        <!-- <div v-if="uploadType == 'bulkUpload'">
          <br>
          <download-button class="downloadClass"></download-button>
          <div class="margintop-24">
            <upload-file/>
          </div>
        </div> -->
        <div class="margintop-24" :key="index">
          <toast-message
            :message="errmsg"
            type="error"
            :isToastEnable="toast"
            @close="(val) => toast = val"
          />
          <div v-for="n in 4" >
            <span class="labels" > Quarter {{n}}</span>
            <div class="fromToFields">
              <tl-select class="custom-width" label="From *" v-model="fromMonths[n-1]"
                :value="fromMonths[n-1]"
                :options="fromMonthsOptions" @change="(val)=>updateFromMonthsArray(val, n)"
                v-validate="{required: true}" :name="`From Month ${n}`" :classname="errors.has(`From Month ${n}`)"
                :errormsg="errors.first(`From Month ${n}`)" @blur="errorMsg()"/>

              <tl-select class="custom-width" label="To *" v-model="toMonths[n-1]"
                :value="toMonths[n-1]"  :options="toMonthsOptions"
                :reduce="filter => `${filter.name}`" @change="(val)=>updateToMonthsArray(val, n)"
                v-validate="{required: true}" :name="`To Month ${n}`" :classname="errors.has(`To Month ${n}`)"
                :errormsg="errors.first(`To Month ${n}`)" />
            </div>
          </div>
        </div>
        <!-- <tick-animation v-if="showSuccessMsg"></tick-animation> -->

      </div>
    </div>

    <bottom-action-container class="placeAtEnd">
      <btn-skip @navClicked="$emit('skip')"></btn-skip>
      <template slot="end">
        <btn-grp>
          <btn text="Previous" type="secondary" @click="$emit('previous')" />
          <btn text="Next" type="primary" @click="saveData" v-show="(ifTeamleaderPermission || ifSuperAdmin || ifAnchor)"/>
        </btn-grp>
      </template>
    </bottom-action-container>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";

export default {
  mounted() {
    (this.uploadType = "manualUpload"), this.fetchAll();
    this.getOrgLeIdList();
  },
  activated() {
    this.fetchAll();
    this.getOrgLeIdList();
  },
  computed: {
    ...mapState("onboard/form24Q", {
      form24QData: state => state.data,
      isFetching: state => state.isFetching,
      isSaving: state => state.isSaving,
      isDeleting: state => state.isDeleting
    }),
    ...mapGetters({
      getleid: "onboard/legal_entities/legal_entity_ID"
    }),
    le_id() {
      if (this.$route.params.entity_index) {
        return this.getleid(this.$route.params.entity_index);
      }
      return this.getleid(0);
    },
    isLoading() {
      return this.isFetching;
    },
    ifAnchor() {
      return localStorage.getItem("userRole") == "ANCHOR" ? true : false;
    },
    ...mapState("onboard/organization", {
      orgIds: state => state.id,
    }),
    ifTeamleaderPermission() {
      if(this.role === 'ADMIN') {
        return true;
      } else if(this.role === 'TEAMLEADER') {
        if(this.miscValue) {
          return true;
        } 
        else {
          return false;
        }
      } else {
        return false
      }

      // if(this.role === 'TEAMLEADER' || this.role === 'ADMIN') {
      //   if(this.miscValue) {
      //   return true;
      //   } else {
      //     return false;
      //   }
      // }
      // else {
      //  return true
      // }
    },
    ifSuperAdmin() {
      return localStorage.getItem("userRole") == "SUPERADMIN" ? true : false;
    },
  },
  data() {
    return {
      uploadType: "manualUpload",
      showBtn: true,
      record: {},
      toast: false,
      errmsg: "",
      fromMonthsOptions: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
      ],
      toMonthsOptions: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
      ],
      tempMonths: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
      ],
      showSuccessMsg: false,
      quarterID: "",
      quartersArray: [],
      toMonths: ["June", "September", "December", "March"],
      fromMonths: ["April", "July", "October", "January"],
      quarters: [
        {
          months: ["April", "May", "June"]
        },
        {
          months: ["July", "August", "September"]
        },
        {
          months: ["October", "November", "December"]
        },
        {
          months: ["January", "February", "March"]
        }
      ],
      index: 0,
      miscValue: false,
      role: ""
    };
  },
  methods: {
    ...mapActions("onboard/form24Q/", {
      act_fetchAll: "fetchAll",
      act_update: "update",
      act_create: "create",
      act_delete: "delete"
    }),

    ...mapActions({
      getOrgLeList: "onboard/organization/getOrgLeIdList",
    }),

    updateFromMonthsArray(val, index) {
      let monthIndex = this.tempMonths.indexOf(val);
      this.fromMonths[index - 1] = this.tempMonths[monthIndex];
      this.quarters[index - 1] = {};

      // PL-2640,PL-2547
      let fromIndex = monthIndex;
      let toIndex = this.tempMonths.indexOf(this.toMonths[index - 1]) + 1;

      if (fromIndex > toIndex) {
        toIndex = toIndex + 12;
        this.quarters[index - 1].months = this.tempMonths.slice(
          fromIndex,
          toIndex
        );
      } else {
        this.quarters[index - 1].months = this.tempMonths.slice(
          fromIndex,
          toIndex
        );
      }
      // PL-2640,PL-2547

      // this.fromMonthsOptions = this.$_.difference( this.fromMonthsOptions, this.tempMonths.slice(monthIndex, monthIndex + 3));
      // this.toMonthsOptions = this.$_.difference( this.toMonthsOptions, this.tempMonths.slice(monthIndex, monthIndex + 3));
    },

    updateToMonthsArray(val, index) {
      let monthIndex = this.tempMonths.indexOf(val);
      this.toMonths[index - 1] = this.tempMonths[monthIndex];
      this.quarters[index - 1] = {};

      // PL-2640,PL-2547
      let fromIndex = this.tempMonths.indexOf(this.fromMonths[index - 1]);
      let toIndex = monthIndex + 1;

      if (fromIndex > toIndex) {
        toIndex = toIndex + 12;
        this.quarters[index - 1].months = this.tempMonths.slice(
          fromIndex,
          toIndex
        );
      } else {
        this.quarters[index - 1].months = this.tempMonths.slice(
          fromIndex,
          toIndex
        );
      }
      // PL-2640,PL-2547
    },

    errorMsg() {
      if (!this.q1FromIndex) {
        this.q1FromMonths = "";
      }
    },
    /** Function to validate and save the form data */
    saveData() {
      if(this.ifAnchor) {
          this.nextPage();
        } else {
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.$_.isEmpty(this.form24QData)) {
            this.create();
          } else {
            this.update();
          }
        } else {
          this.$el
            .querySelector(
              '[data-vv-name="' + this.$validator.errors.items[0].field + '"]'
            )
            .focus();
          this.$el
            .querySelector(
              '[data-vv-name="' + this.$validator.errors.items[0].field + '"]'
            )
            .scrollIntoView({
              behavior: "smooth",
              block: "center",
              inline: "center"
            });
        }
      });
      }
    },
    /** To fetch the data from serve and populate the form data */
    async fetchAll() {
      try {
        let res = await this.act_fetchAll(this.le_id);
        //console.log("Form Q", res);
        if (res.data.payload.data.quarter) {
          this.quarters = res.data.payload.data.quarter;
        }

        for (var i = 0; i < this.quarters.length; i++) {
          this.fromMonths[i] = this.quarters[i].months[0];
          this.toMonths[i] = this.quarters[i].months[
            this.quarters[i].months.length - 1
          ];
        }

        this.index += 1;

        if (res.message != null) {
          throw Error(res.message);
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = "No Setting Found! Loading default Setting";
      }
    },
    /* function to hide success message and navigate to next screen */
    hideSuccessMsg() {
      setTimeout(() => {
        this.showSuccessMsg = false;
        this.$emit('next');
      }, 1000);
    },

    /** Function to save the form data to server while creating first time */
    async create() {

      this.quartersArray = [];
      let overlap = [];
      /** Logic to check whether any time interval is over lapped */
      for (let i = 0; i < 4; i++) {
        for (let j = i + 1; j < 4; j++) {
          overlap = this.$_.intersection(
            this.quarters[i].months,
            this.quarters[j].months
          );
          if (!this.$_.isEmpty(overlap)) {
            this.toast = true;
            this.errmsg = "Overlapping months between Quarters";
            return;
          }
        }
      }

      if (!this.$_.isEmpty(overlap)) {
        this.toast = true;
        this.errmsg = "Overlapping months between Quarters";
        return;
      }

      let totalSelectedMonthsArray = [];

      for (let i = 0; i < 4; i++) {
        let quarterMonthsArray = this.quarters[i].months;
        for (let k = 0; k < quarterMonthsArray.length; k++) {
          let month = quarterMonthsArray[k];
          totalSelectedMonthsArray.push(month);
        }
        let quarterData = {
          id: `Quarter ${i + 1}`, //+ this.quarterID,
          months: this.quarters[i].months
        };
        this.quartersArray.push(quarterData);
      }

      if (totalSelectedMonthsArray.length < 12) {
        this.toast = true;
        this.errmsg = "Please select every month in the quarter";
        return;
      }

      let obj = {
        data: {
          le_id: this.le_id,
          quarter: this.quartersArray //[{ quarter: "Q1", months: ["March"] }, { quarter: "Q2", months: ["April"] },]
        }
      };
      try {
        this.$root._data.isSaving = true;
        let res = await this.act_create(obj.data);
        setTimeout(() => {
          if (res.status == 200 || res.status == 201) {
            this.showSuccessMsg = true;
            this.hideSuccessMsg();
          }
          this.fetchAll();
          this.$root._data.isSaving = false;
        }, 500);
      } catch (err) {
        this.$root._data.isSaving = false;
        this.toast = true;
        this.errmsg = err;
      }
    },

    /** Function to submit the form data to server while updating existing data*/
    async update() {

      this.quartersArray = [];
      let overlap = [];
      /** Logic to check whether any time interval is over lapped */
      for (let i = 0; i < 4; i++) {
        for (let j = i + 1; j < 4; j++) {
          overlap = this.$_.intersection(
            this.quarters[i].months,
            this.quarters[j].months
          );
          if (!this.$_.isEmpty(overlap)) {
            this.toast = true;
            this.errmsg = "Overlapping months between Quarters";
            return;
          }
        }
      }

      if (!this.$_.isEmpty(overlap)) {
        this.toast = true;
        this.errmsg = "Overlapping months between Quarters";
        return;
      }

      let totalSelectedMonthsArray = [];

      for (let i = 0; i < 4; i++) {
        let quarterMonthsArray = this.quarters[i].months;
        for (let k = 0; k < quarterMonthsArray.length; k++) {
          let month = quarterMonthsArray[k];
          totalSelectedMonthsArray.push(month);
        }
        let quarterData = {
          id: `Quarter ${i + 1}`, //+ this.quarterID,
          months: this.quarters[i].months
        };
        this.quartersArray.push(quarterData);
      }

      if (totalSelectedMonthsArray.length < 12) {
        this.toast = true;
        this.errmsg = "Please select every month in the quarter";
        return;
      }

      let obj = {
        data: {
          le_id: this.le_id,
          quarter: this.quartersArray //[{ quarter: "Q1", months: ["March"] }, { quarter: "Q2", months: ["April"] },]
        }
      };
      try {
        this.$root._data.isSaving = true;
        let res = await this.act_update(obj.data);
        setTimeout(() => {
          if (res.status == 200 || res.status == 201) {
            this.showSuccessMsg = true;
            this.hideSuccessMsg();
          }
          this.fetchAll();
          this.$root._data.isSaving = false;
        }, 500);
      } catch (err) {
        this.$root._data.isSaving = false;
        this.toast = true;
        this.errmsg = err;
      }
    },

    /* function is use to move next page as user role is anchor */
    nextPage() {
      this.$emit("next");
    },

    async getOrgLeIdList() {
      const org = this.orgIds;
      const le = this.le_id;
      //console.log("Org:",org);
      //console.log("Le ID",le);
      let bodyParams = {};
      let  data = await this.getOrgLeList({
        data: {
            ...bodyParams
        }
      });
      this.role = data.data.user.userRole;
      this.miscValue = data.data.user.permissions.misc ? true : false;
      //console.log("PL-3406",data);
    }
  }
};
</script>
<style lang="scss" scoped>
@import "@/scss/components/margins.scss";
.udfFields {
  display: flex;
}

.custom-width {
  width: 205px;
  margin-right: 35px;
  margin-bottom: 16px;
  margin-top: 16px;
}

.labels {
  font-size: 14px;
  margin-top: 35px;
  font-weight: 600;
  color: #646464; // margin-bottom: 15px;
}

.addBtn {
  width: 205px;
  height: 35px;
  border-radius: 4px;
  box-shadow: 2px 2px 8px 0 rgba(0, 0, 0, 0.1);
  border: solid 1px #37c6c0;
  background-color: #ffffff;
  font-size: 14px;
  font-weight: bold;
  text-align: center;
  color: #37c6c0;
  margin-left: 20px;
  margin-bottom: 40px;
}

.udfDetails {
  margin-bottom: 110px;
}

.fromToFields {
  display: flex;
}

.permission-alert-msg {
  background-color: #f8d7da;
  padding: 1rem 1rem;
  margin-top: 1rem;
  margin-bottom: 1rem;
  font-weight: 600;
  color: #842029;
  border: 1px solid transparent;
  border-radius: .25rem;
  border-color: #f5c2c7;
}
</style>
